import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  // 滚动到顶部的处理函数
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // 在新标签页打开链接的处理函数
  const openInNewTab = (url) => {
    // 添加完整的域名和端口
    const baseUrl = window.location.origin; // 获取当前站点的完整URL
    const fullUrl = `${baseUrl}${url}`;
    window.open(fullUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="elegant-footer">
      <div className="elegant-footer-content">
        <div className="elegant-footer-logo">灌汤社区 HugTub</div>
        <div className="elegant-footer-links">
          <a 
            href="/about" 
            onClick={(e) => {
              e.preventDefault();
              openInNewTab('/about');
            }}
          >关于我们</a>
          <a 
            href="/contact" 
            onClick={(e) => {
              e.preventDefault();
              openInNewTab('/contact');
            }}
          >联系我们</a>
          <a 
            href="/agreement" 
            onClick={(e) => {
              e.preventDefault();
              openInNewTab('/agreement');
            }}
          >用户协议</a>
          <a 
            href="/privacy" 
            onClick={(e) => {
              e.preventDefault();
              openInNewTab('/privacy');
            }}
          >隐私政策</a>
        </div>
        <div className="elegant-footer-copyright">
          © 2025 Shenzhen HugTech Nexus Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer; 